import React, { memo } from 'react';
import { currencyFormatter } from 'util/locale';

interface DeltaValueCellProps {
  currency: string;
  delta: number;
}

export const DeltaValueCell = memo(function DeltaValueCell({ delta, currency }: DeltaValueCellProps) {
  const isPositive = Number(delta) > 0;

  return (
    <span data-delta-positive={isPositive} className='delta'>
      {`${isPositive ? '+' : ''}${currencyFormatter(delta, currency, { round: true })}`}
    </span>
  );
});

